export const JOB_POSTING_PLANS = [
  {
    id: 'basic',
    name: 'Basic Job Posting',
    price: 0,
    description: 'Standard job listing to attract candidates for open roles.',
  },
  {
    id: 'enhanced',
    name: 'Enhanced Job Posting',
    price: 29,
    description: 'Greater visibility for your hiring position across the platform.',
    highlight: true,
  },
  {
    id: 'premium',
    name: 'Premium Job Posting',
    price: 99,
    description: 'Maximum visibility for priority roles and key hires.',
  },
];

export const getJobPlan = (planId) =>
  JOB_POSTING_PLANS.find((plan) => plan.id === planId) || JOB_POSTING_PLANS[0];

export const isFreeJobPlan = (planId) => getJobPlan(planId).price <= 0;
